









import Vue, { PropType } from 'vue';

import ImageGrid from '@/containers/image-grid';
import documentCtxMixin from '../document-ctx';

import { DynamicDocumentItem, DynamicDocumentItemData, Nullable } from '@/types';

export default documentCtxMixin.extend({
  components: {
    ImageGrid,
  },

  props: {
    item: Object as PropType<DynamicDocumentItem>,
    data: Object as PropType<DynamicDocumentItemData>,
    isActive: Boolean,
  },

  data() {
    return {
      isOpen: false,
      timeout: null as Nullable<number>,
    };
  },

  watch: {
    isActive: {
      immediate: true,
      handler(val: boolean) {
        if (this.timeout) window.clearTimeout(this.timeout);

        if (val) this.isOpen = val;
        else this.timeout = window.setTimeout(() => (this.isOpen = false), 500);
      },
    },
  },
});
